var React = require('react');

function Android (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M29.485 8.075a1.041 1.041 0 1 1 1.863.932l-2.975 5.953A16.66 16.66 0 0 1 36.653 30H3.345a16.66 16.66 0 0 1 8.28-15.04L8.65 9.01a1.042 1.042 0 0 1 1.863-.935l2.975 5.95c2-.848 4.2-1.318 6.51-1.318a16.6 16.6 0 0 1 6.507 1.32l2.975-5.95.005-.002zM15 22.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0zM27.5 25a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z","fill":"#fff"}));
}

Android.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = Android;

Android.default = Android;
